module.exports = __webpack_public_path__ + "static/img/icon-to-top.dabb242a.png";